import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const MyTaskSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M10 1.33334H6.00004C5.63185 1.33334 5.33337 1.63182 5.33337 2.00001V3.33334C5.33337 3.70153 5.63185 4.00001 6.00004 4.00001H10C10.3682 4.00001 10.6667 3.70153 10.6667 3.33334V2.00001C10.6667 1.63182 10.3682 1.33334 10 1.33334Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6666 2.66666H12C12.3536 2.66666 12.6927 2.80714 12.9428 3.05718C13.1928 3.30723 13.3333 3.64637 13.3333 3.99999V13.3333C13.3333 13.6869 13.1928 14.0261 12.9428 14.2761C12.6927 14.5262 12.3536 14.6667 12 14.6667H3.99996C3.64634 14.6667 3.3072 14.5262 3.05715 14.2761C2.8071 14.0261 2.66663 13.6869 2.66663 13.3333V3.99999C2.66663 3.64637 2.8071 3.30723 3.05715 3.05718C3.3072 2.80714 3.64634 2.66666 3.99996 2.66666H5.33329"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 7.33334H10.6667" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 10.6667H10.6667" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.33337 7.33334H5.34004"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33337 10.6667H5.34004"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default MyTaskSVG;
